import styled, { css } from 'styled-components';
import { COLORS, MAX_SCREEN } from '@themes';
import IMG from '@assets/dashboard';

const margin = 2;
type TextProps = {
  $minSize?: number | string;
  $maxSize?: number | string;
  top?: number | string;
  left?: number | string;
  weight?: number | string;
  right?: number | string;
  lh?: number | string;
};

export const Text = styled.div.attrs((props) => ({}))<TextProps>`
  ${({ $maxSize, top, left, weight, right, lh, $minSize }) => css`
    font-size: ${$maxSize}vw;
    margin-top: ${top};
    margin-left: ${left};
    margin-right: ${right};
    font-weight: ${weight || 'bold'};
    line-height: ${lh || 'none'};

    @media (max-width: ${MAX_SCREEN}px) {
      font-size: ${$minSize}px;
    }
  `}
`;

export const Style = styled.div`
  font-family: Din;
  color: ${COLORS.BLACK_1};
  min-width: calc(${MAX_SCREEN}px - ${margin}%);
  min-height: 760px;
  display: flex;
  flex-direction: column;
  height: 100vh;
  background-image: url(${IMG['BG.svg']});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;

  .flex {
    display: flex;
  }

  .content {
    z-index: 1;
    flex: 1;
    justify-content: center;
    align-items: center;
    background-color: ${COLORS.WHITE_1};
    border-radius: 20px;
    margin: ${margin}% 6%;
    padding: 0% 3%;
    display: flex;
    height: fit-content;
    .box-content {
      width: 100%;
      /* height: 100%; */
    }

    @media (max-width: ${MAX_SCREEN}px) {
      min-height: 690px;
    }
  }
  .logo {
    position: relative;
    margin-left: -12px;
    margin-top: 12px;
    height: 5vh;
  }
  .img {
    width: 3%;
  }
`;
